import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useDispatch, useSelector } from "react-redux";
import Purchasetable from "./purchasetable";
import { toast } from "react-toastify";
import { IconButton } from "@mui/material";
import { GetDepositlist } from "../../redux/slices/depositlist";
import { rotate } from "../../components/rotate/RefreshRotateAnimation";
import RefreshIcon from "@mui/icons-material/Refresh";
import { ablyClient } from "../../lib/socket";
import PaymentMethodModal from "../../components/modal/depositmodal";
import { PaymentSend } from "../../redux/slices/transpicture";

const Userpurchase = () => {
  const [amount, setAmount] = useState("");
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const { user } = useSelector((state) => state.login);
  const balance = useSelector((value) => value?.ubal?.data?.balance);
  const predefinedAmounts = [10, 20, 40, 50, 100];
  const dispatch = useDispatch();
  const { loading } = useSelector((u) => u?.bank);
  const { loading: isLoading } = useSelector((list) => list.dplist);
  const { interacting: activeModal } = useSelector((tate) => tate.gift);

  const handleAmountClick = (amount) => {
    setSelectedAmount(amount);
    setAmount(amount);
  };

  const handleProceed = () => {
    const enteredAmount = parseInt(amount) || selectedAmount;
    if (!enteredAmount || enteredAmount < 10) {
      toast.error("Please add a minimum of $10");
      return;
    }
    setShowModal(true);
  };

  const handleRefresh = () => {
    dispatch(GetDepositlist());
  };

  // Ably real-time updates
  useEffect(() => {
    const channel = ablyClient.channels.get("my-channel-deposit");
    channel.subscribe("update", (message) => {
      console.log("Received:", message.data);
    });
    return () => {
      channel.unsubscribe();
    };
  }, []);

  const handleConfirm = async ({ method, attach }) => {
    if (!attach && method !== "card") {
      toast.info("Uploading screenshot is required");
      return;
    }
    const payload = {
      id: user?.id,
      amount: amount,
      attach,
      company: method,
      ...(activeModal === "deposit" && { bonus: 100 }),
    };

    await dispatch(PaymentSend(payload));
    setShowModal(false);
  };

  return (
    <div className="rounded-lg shadow-lg custom-container mx-auto mt-5 pl-3 w-full pb-20">
      <div className="rounded-lg mb-3 overflow-hidden max-h-[300px]">
        <img src="/images/banner/banner-111.jpg" />
      </div>
      {/* Balance Section */}
      <div className="flex justify-between items-center mb-3 px-1">
        <span className="text-lg font-semibold text-white">
          Your Balance
          <IconButton
            onClick={handleRefresh}
            disabled={isLoading}
            sx={{
              ml: 2,
              animation: isLoading ? `${rotate} 1s linear infinite` : "none",
              backgroundColor: "#e00e84",
              color: "white",
              "&:hover": { backgroundColor: "#e00e84" },
              "&:disabled": { backgroundColor: "#c74d98" },
            }}
          >
            <RefreshIcon />
          </IconButton>
        </span>
        <span className="text-lg font-semibold mr-3">
          ${balance ? balance : 0}
        </span>
      </div>

      {/* Amount Selection */}
      <div className="flex flex-col md:flex-row items-center">
        <div className="flex space-x-1 sm:space-x-2 mb-0 w-full">
          {predefinedAmounts.map((value) => (
            <div
              key={value}
              onClick={() => handleAmountClick(value)}
              className={`cursor-pointer border-2 rounded-md p-2 w-full sm:w-20 text-center ${
                selectedAmount === value
                  ? "bg-[#e2008a] text-white"
                  : "gradient-btns text-black font-bold border-[#000]"
              }`}
            >
              ${value}
            </div>
          ))}
        </div>

        {/* Input + Proceed */}
        <div className="flex flex-col mr-3 md:flex-row items-center w-full md:w-auto mt-4 ml-2">
          <div className="relative flex items-center w-full md:w-[330px]">
            <input
              type="text"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Enter Amount"
              className="bg-transparent border-2 mb-4 rounded-md p-[6px] border-[#fff] outline-none w-full"
            />
            <span className="absolute right-2 top-2 text-[20px]">$</span>
          </div>
          <button
            onClick={handleProceed}
            className="bg-[#e2008a] text-white font-semibold px-4 mb-4 py-[10px] rounded-md transition duration-200 ml-2 w-full md:w-52 text-center"
          >
            {loading ? (
              <div className="spinner-border text-light" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              "Proceed"
            )}
          </button>
        </div>
      </div>

      <Purchasetable user={user?.id} />
      <PaymentMethodModal
        open={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleConfirm}
      />
    </div>
  );
};

export default Userpurchase;
